'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.rentalWizardButton = rentalWizardButton;
/*@ngInject*/

function rentalWizardButton() {
    return {
        restrict: 'A',
        replace: false,
        require: '^rentalWizard',
        link: function link($scope, $element, $attrs, wizard) {
            var action;

            if ($attrs.wzNext !== undefined) {
                action = 'next';
            } else if ($attrs.wzPrevious !== undefined) {
                action = 'previous';
            } else if ($attrs.wzFinish !== undefined) {
                action = 'finish';
            } else if ($attrs.wzCancel !== undefined) {
                action = 'cancel';
            }

            $element.on('click', function (e) {
                if ($attrs.wzValid !== 'false') {
                    e.preventDefault();
                    $scope.$apply(function () {
                        wizard[action]();
                    });
                }
                return;
            });
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ./features/rental/components/rental-checkout-wizard/rental-wizard-button.js
// module id = 992
// module chunks = 0